import { Button, Card, Col, Collapse, Empty, Row, Table, message } from "antd";
import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { FiCopy, FiFilm } from "react-icons/fi";
import { Link, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { api, api_url } from "../../../services/api";
import { getProfileLocal, setProfileLocal } from "../../../utils/common";

import { ImAttachment } from "react-icons/im";
import Models from "../Models";
import Title from "antd/es/typography/Title";
import { theme } from "antd";

const { useToken } = theme;
const { Panel } = Collapse;

const types = {
  0: 'Outros',
  1: 'Youtube',
  2: 'Vimeo',
  3: 'Vídeo',
  4: 'Webinar',
  5: 'Aúdio',
  6: 'Ebook',
  7: 'Arquivo',
  8: 'Texto',
  9: 'Imagem',
}

const Additional = () => {
  const isFile = [3, 5, 6, 7, 9,]
  const { token } = useToken();
  const { hash } = useParams();

  const [modules, setModules] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);

  const [openKey, setOpenKey] = useState(null);
  const [openLessonKey, setOpenLessonKey] = useState(null);

  const handleAccordion = (key) => {
    setOpenKey(openKey === key ? null : key);
  };

  const handleLessonKey = (key) => {
    setOpenLessonKey(openLessonKey === key ? null : key);
  };

  const getModules = async () => {

    try {

      const { data: response } = await api.get(`/panel/student-courses/${hash}`);
      setModules(response.data?.course_modules);
      

    } catch (error) {
      console.log(error);
      message.error('Erro ao carregar conteúdos adicionais');
    }

  }


  useEffect(() => {
    getModules();
  }, []);


  return (
    <section>
      <Card style={{ padding: 16, backgroundColor: "#FFF", marginTop: 20 }}>
        <h2 style={{ fontSize: "font-size: calc(1.5rem + 0.3vw)" }}>
          Módulos e Aulas
        </h2>
        <Collapse bordered={false} onChange={handleAccordion} activeKey={openKey}>
          {modules?.filter(item => {

            const hasLessonsAndAdditionalContent = item?.lessons.filter(lesson => lesson?.additional_contents?.length > 0).length > 0;

            return hasLessonsAndAdditionalContent;

          })?.map((item, index) => (
            <Panel
              header={
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: token.colorPrimary,
                    fontWeight: "bold",
                  }}
                >
                  <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                    {item.name}
                  </span>
                  <div>
                    <span style={{ marginRight: "10px" }}>
                      {item.lessons.length}
                    </span>
                    <span>{item?.course_period_hours}</span>
                  </div>
                </Row>
              }
              key={`${item.id}-${item.name}`}
            >
              {item?.lessons?.filter(item => {

                return item?.additional_contents?.length > 0;

              })?.map((lesson) => (
                <div 
                  style={{
                    marginTop: 10,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: token.colorPrimary,
                    fontWeight: "bold",
                  }}
                >
                  <Button
                    onClick={() => setSelectedModule(lesson)}
                  >
                    {lesson.name}
                  </Button>
                </div>
              ))}
            </Panel>
          ))}
        </Collapse>
      </Card>
      <Card
        title={`Aula: ${!!selectedModule?.name && selectedModule?.name}`}
        style={{ padding: 16, backgroundColor: "#FFF", marginTop: 20 }}
      >
        <Table
          dataSource={selectedModule?.additional_contents}
          columns={[
            {
              title: 'Nome',
              dataIndex: 'name',
              key: 'name',
            },
            {
              title: 'Tipo',
              dataIndex: 'type',
              key: 'type',
              render: (_, lesson) => <>{types[lesson?.type]}</>

            },
            {
              title: 'Ações',
              dataIndex: 'actions',
              key: 'actions',
              width: '200px',
              render: (_, lesson) => (
                <div>
                  <Button
                    icon={!isFile.includes(lesson?.type) ? <EyeOutlined /> : <DownloadOutlined />}
                    onClick={async () => {
                      if (!isFile.includes(lesson?.type)) {
                        window.open(lesson?.link, '_blank')
                      } else {

                        const url = `${api_url}/upload/${lesson?.path}`

                        window.open(url, '_blank')


                      }
                    }}
                  />
                </div>
              )
            }
          ]}



        />

      </Card>
    </section>
  );
};
export default Additional;
